import React from 'react'

import Spin from 'pared/components/basicUi/spin'
import Table from 'pared/components/basicUi/table'

import ChartContainer from './ChartContainer'
import { IFoodListFragmentType } from './gqls/foodList'
import useConfig from './hooks/useConfig'
import useFoodListColumns from './hooks/useFoodListColumns'

interface IPropsType {
  listLocationGroupMenuItemsRecords: IFoodListFragmentType[]
  loading: boolean
}

const rowStyle = `
  &:first-child td:not(:nth-child(3)) {
    vertical-align: bottom;
    line-height: 26px;
  }
`

const FoodList = ({
  listLocationGroupMenuItemsRecords,
  loading,
}: IPropsType) => {
  const config = useConfig()
  const isSalesMix = config.isSalesMix
  const columns = useFoodListColumns(listLocationGroupMenuItemsRecords)
  const filteredColumns = columns.filter(
    ({ key }) =>
      (key !== 'profitablity' && key !== 'salesMix') ||
      (!isSalesMix && key === 'profitablity') ||
      (isSalesMix && key === 'salesMix'),
  )

  return (
    <ChartContainer>
      <Spin spinning={loading}>
        <Table<IFoodListFragmentType>
          columns={filteredColumns}
          dataSource={listLocationGroupMenuItemsRecords}
          rowStyle={rowStyle}
          rowKey={(values) => {
            return `${values.itemName} @ ${values.category}`
          }}
          defaultSortedField="popularity"
        />
      </Spin>
    </ChartContainer>
  )
}

export default React.memo(FoodList) as unknown as typeof FoodList
